const openAccessData = [
  {
    id: 1,
    serialNumber: "001",
    title: "Khan Academy",
    link: "https://www.khanacademy.org/"
  },
  {
    id: 2,
    serialNumber: "002", 
    title: "CrashCourse",
    link: "https://thecrashcourse.com/"
  },
  {
    id: 3,
    serialNumber: "003",
    title: "Coursera",
    link: "https://www.coursera.org/"
  },
  {
    id: 4,
    serialNumber: "004",
    title: "Journals",
    link: "https://www.journals.elsevier.com/"
  },
  {
    id: 5,
    serialNumber: "005",
    title: "Academic Journals",
    link: "https://academicjournals.org/"
  },
  {
    id: 6,
    serialNumber: "006",
    title: "Directory of Open Access Journals",
    link: "https://doaj.org/"
  },
  {
    id: 7,
    serialNumber: "007",
    title: "E-Journals.org",
    link: "https://www.e-journals.org/"
  },
  {
    id: 8,
    serialNumber: "008",
    title: "OPEN Education",
    link: "https://www.open.edu/"
  },
  {
    id: 9,
    serialNumber: "009",
    title: "EPGPathshala",
    link: "https://epgp.inflibnet.ac.in/"
  },
  {
    id: 10,
    serialNumber: "010",
    title: "Infoplease",
    link: "https://www.infoplease.com/"
  },
  {
    id: 11,
    serialNumber: "011",
    title: "NPTEL",
    link: "https://nptel.ac.in/"
  },
  {
    id: 12,
    serialNumber: "012",
    title: "Reference",
    link: "https://www.reference.com/"
  },
  {
    id: 13,
    serialNumber: "013",
    title: "India Press",
    link: "https://www.pressinformation.nic.in/"
  },
  {
    id: 14,
    serialNumber: "014",
    title: "India.gov.in (National portal of India)",
    link: "https://www.india.gov.in/"
  },
  {
    id: 15,
    serialNumber: "015",
    title: "Theses/Dissertations",
    link: "https://www.proquest.com/dissertations-theses/"
  },
  {
    id: 16,
    serialNumber: "016",
    title: "Shodhganga",
    link: "https://shodhganga.inflibnet.ac.in/"
  },
  {
    id: 17,
    serialNumber: "017",
    title: "ShodhGangotri",
    link: "https://shodhgangotri.inflibnet.ac.in/"
  },
  {
    id: 18,
    serialNumber: "018",
    title: "Faculty Profile",
    link: "https://www.facultyprofile.com/"
  },
  {
    id: 19,
    serialNumber: "019",
    title: "IRINS",
    link: "https://irins.org/"
  },
  {
    id: 20,
    serialNumber: "020",
    title: "ORCID",
    link: "https://orcid.org/"
  },
  {
    id: 21,
    serialNumber: "021",
    title: "Vidwan",
    link: "https://vidwan.inflibnet.ac.in/"
  }
];

export default openAccessData;